"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventSystem = void 0;
var eventemitter3_1 = require("eventemitter3");
var createEventSystem = function () {
    var emitter = new eventemitter3_1.EventEmitter();
    var removeSubscription = function (_a) {
        var key = _a.key, handler = _a.handler;
        emitter.off(key, handler);
    };
    var dispatch = function (key, payload) {
        if (payload === void 0) { payload = {}; }
        emitter.emit(key, payload);
    };
    var addSubscription = function (_a) {
        var key = _a.key, handler = _a.handler;
        emitter.on(key, handler);
        return function () { return removeSubscription({ key: key, handler: handler }); };
    };
    var addSubscriptions = function (subscriptions) {
        var subscriptionRemovers = subscriptions.map(addSubscription);
        return function () { return subscriptionRemovers.forEach(function (remove) { return remove(); }); };
    };
    var removeSubscriptions = function (subscriptions) {
        return subscriptions.forEach(removeSubscription);
    };
    return {
        dispatch: dispatch,
        addSubscription: addSubscription,
        addSubscriptions: addSubscriptions,
        removeSubscription: removeSubscription,
        removeSubscriptions: removeSubscriptions,
    };
};
exports.createEventSystem = createEventSystem;
